import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSearchBox } from 'react-instantsearch';

import { SearchSortBy } from '@uncinc/react-searchkit';
import type { SearchSortByProps } from '@uncinc/react-searchkit/dist/components/SortBy';

import { APP_OPTIONS } from '../../../config/constants';

import './style.scss';

const SearchForumSortBy: React.FC<Omit<SearchSortByProps, 'inputType' | 'items'>> = (props) => {
  const { className, ...restProps } = props;

  const { query } = useSearchBox();
  const { t } = useTranslation('translation', { keyPrefix: 'components.search_forum.sort_by' });

  const classes = c('SearchForum__SortBy', className);

  // Only show stats if there's a search query.
  if (!query || query.trim() === '') {
    return null;
  }

  return (
    <SearchSortBy
      {...restProps}
      inputType="select"
      className={classes}
      items={[
        {
          label: t('items.score'),
          value: `${APP_OPTIONS.parameters.searchkitIndexForumThread}`,
        },
        {
          label: t('items.created_asc'),
          value: `${APP_OPTIONS.parameters.searchkitIndexForumThread}_created_asc`,
        },
        {
          label: t('items.created_desc'),
          value: `${APP_OPTIONS.parameters.searchkitIndexForumThread}_created_desc`,
        },
      ]}
    />
  );
};

export default SearchForumSortBy;
